<div class="flex flex-col justify-center items-center gap-[1rem]" [ngClass]="styleClass()">
  @if (showIcon()) {
    <svg-icon
      [src]="iconSrc()"
      [name]="iconName()"
      [style.width]="iconSize()"
      [style.height]="iconSize()"
      [style.color]="iconColor()"></svg-icon>
  }

  <div class="text-[0.875rem] leading-[150%] font-[600] text-center" [style.color]="textColor()">
    <ng-content></ng-content>
  </div>
</div>
